import gql from 'graphql-tag'

export const GET_MENU_ITEM_FULL = gql`
  fragment menuLevel on MenuItem {
    id
    name
    icon
    label
    url
    hasChildren
    image {
      imageId
      format
    }
  }

  fragment menuBanner on MenuItemBanners {
    banner {
      bannerId
      gaTag
      mediaId
      type
      url
      urlNewWindow
    }

    brandBanners {
      title
      bannerId
      gaTag
      mediaId
      title
      url
      urlNewWindow
    }
  }

  query getMenu(
    $fullMenu: Boolean = false
    $abTestVersion: String
    $menuType: String!
    $menuVersion: String
  ) {
    getMenu(
      menuId: {
        menuType: $menuType
        menuVersion: $menuVersion
        abTestVersion: $abTestVersion
      }
    ) {
      data {
        id
        name
        image {
          imageId
          format
        }
        url
        hasChildren
        banners @include(if: $fullMenu) {
          ...menuBanner
        }
        children @include(if: $fullMenu) {
          ...menuLevel
          customData
          children {
            ...menuLevel
            children {
              ...menuLevel
            }
          }
        }
      }
    }
  }
`
